import { Only } from '@cbhq/cdx-components';
import { DesktopSidebar } from './DesktopSidebar.js';
import { MobileSidebar } from './MobileSidebar.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function Sidebar({
  anchors = [],
  showSocialSharingLinks
}) {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Only, {
      on: "phone",
      children: /*#__PURE__*/jsx(MobileSidebar, {
        anchors: anchors,
        showSocialSharingLinks: showSocialSharingLinks
      })
    }), /*#__PURE__*/jsx(Only, {
      on: ['tablet', 'desktop'],
      children: /*#__PURE__*/jsx(DesktopSidebar, {
        anchors: anchors,
        showSocialSharingLinks: showSocialSharingLinks
      })
    })]
  });
}
export { Sidebar };
//# sourceMappingURL=Sidebar.js.map
